module.exports = __webpack_public_path__ + "54ee22271ea3a84f19adc7a4bb988261.png";